import styled from '@emotion/styled';
import { SectionText } from '@presentation/components';

export const Text = styled(SectionText)`
  margin: 20px 0;
  text-align: center;
`;
